import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import {
  Button,
  Popconfirm,
  Modal,
  DatePicker
} from 'antd';
import {
  reloadLeadsAtom,
  viewPayoutAtom,
  notificationsAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function LeadPayoutDateModal() {
  const { t } = useTranslation();
  const [viewPayout, setViewPayout] = useRecoilState(viewPayoutAtom);
  const [reloadLeads, setReloadLeads] = useRecoilState(reloadLeadsAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [payoutDate, setPayoutDate] = useState(null);
  const [applyingPayout, setApplyingPayout] = useState(false);

  function applyPayoutDate() {
    setApplyingPayout(true);
    const payoutDateString = dayjs(payoutDate).add(4, 'hour').format('YYYY-MM-DDTHH:mm:ss');
    api.post('leads/update', {
      ...viewPayout,
      payoutDate: payoutDateString
    })
      .then((response) => {
        setApplyingPayout(false);
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
          setReloadLeads(true);
          setViewPayout(null);
        }
      })
      .catch((error) => {
        setApplyingPayout(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    if (viewPayout) {
      if (viewPayout?.payoutDate) {
        setPayoutDate(dayjs(viewPayout?.payoutDate).format('MMM DD, YYYY'));
      } else {
        setPayoutDate(dayjs().format('MMM DD, YYYY'));
      }
    }
  }, [viewPayout]);

  return (
    <Modal
      title={t('payout_date')}
      zIndex={999}
      open={viewPayout}
      onCancel={() => setViewPayout(null)}
      footer={[
        <>
          {viewPayout?.activationDate && (
            <Button
              key="update"
              type="primary"
              loading={applyingPayout}
              onClick={() => applyPayoutDate()}
            >
              {t('update')}
            </Button>
          )}
          {!viewPayout?.activationDate && (
            <Popconfirm
              onConfirm={() => applyPayoutDate()}
              title={t('are_you_sure_set_payout_date_not_installed_prompt')}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Button
                loading={applyingPayout}
                key="update"
                type="primary"
              >
                {t('update')}
              </Button>
            </Popconfirm>
          )}
        </>
      ]}
    >
      <DatePicker
        format="YYYY-MM-DD"
        className="w-full"
        inputReadOnly
        onChange={(date) => {
          setPayoutDate(date.format('MMM DD, YYYY'))
        }}
        disabled={applyingPayout}
        value={dayjs(payoutDate)}
        showSecond={false}
        type="primary"
        size="small"
        placement="bottomLeft"
      />
    </Modal>
  );
}

export default LeadPayoutDateModal;
